import { accessToken } from './accessToken';

const ACCEPTED_JSON_MEDIA_TYPES = 'application/json, application/problem+json';

export const prepareHeaders = (headers: Headers) => {
    const token = accessToken.getAccessToken();
    if (token) {
        headers.set('authorization', `Bearer ${token}`);
        headers.set('Content-Type', 'application/json');
        headers.set('Accept', ACCEPTED_JSON_MEDIA_TYPES);
    }
    return headers;
};

export const getHeadersInit = (init: Record<string, string> = {}) => {
    const token = accessToken.getAccessToken();
    if (token) {
        init.Authorization = `Bearer ${token}`;
        init.Accept = ACCEPTED_JSON_MEDIA_TYPES;
    }
    return init;
};
